import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import styled from "styled-components";
import { PlateLeaf, type PlateLeafProps } from "@platejs/core/react";
export const KbdLeaf: FC<PlateLeafProps> = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <Kbd as="kbd" {...props}>{children}</Kbd>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const Kbd = styled(PlateLeaf)`
	background-color: white;
	border: 1px solid black;
	border-radius: 3px;
	box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.75);
	font-size: 75%;
	font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo,
		Courier, monospace;
	line-height: normal;
	margin-right: 0.2em;
	padding: 0.2em 0.4em;
	white-space: pre-wrap;
`;